/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["nav[_ngcontent-%COMP%]{padding:8px 16px;font-size:30px;background:#333;min-height:100vh}nav[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]{text-decoration:none;color:rgba(255,255,255,.7)}"];
export { styles as styles };
